module.exports = __webpack_public_path__ + "img/show_track.04210cfe.svg";